<template>
  <div class="page-404 error el-main">
    <div class="content">
      <div class="header">
      <nav aria-label="breadcrumb">
        <ol class="bread clearfix">
          <li><a href="/"><i class="fas fa-home mint"></i></a></li>
        </ol>
      </nav>
      </div>
      <div class="card">
        <div class="card-body text-center">
          <img src="/static/img/invalid-name.png" />
          <h1>요청하신 페이지를 찾을 수 없습니다.(404)</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pageNotFound',
  data () {
    return {
      title: 'Error 404'
    }
  },
  head: {
    title: function () {
      return {
        inner: this.title
      }
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
  $--color-primary: yellow;
  $--default-font-size: 10.0em;

  .scss_test {
    color: $--color-primary;
    font-size: $--default-font-size;
  }
</style>

<style lang="less" scoped>
  @baseColor: black;
  @baseFontSize: 10.0em;

  .less_test {
    color: @baseColor;
    font-size: @baseFontSize;
  }
</style>



// WEBPACK FOOTER //
// src/pages/errors/404.vue